var map = {
	"./no-image": 846,
	"./no-image.png": 846,
	"./sm_favicon.ico": 964,
	"./snackmagic-name-logo": 564,
	"./snackmagic-name-logo.png": 564,
	"./stadium": 854,
	"./stadium.png": 854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;